// Shared display helpers for the cook pages.

export const fmtDuration = seconds => {
  if (seconds === null || seconds === undefined) return '—';
  const m = Math.round(seconds / 60);
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}m`;
};

export const fmtTemp = c => (c === null || c === undefined ? '—' : `${Number(c).toFixed(1)}°C`);

export const fmtWeight = g => (g ? `${(g / 1000).toFixed(2)} kg` : '—');

// cookcast's food category codes (cookcast/cookcast/categories.py). Anything
// else, such as a hand-configured type, shows as its code in words.
const FOOD_CATEGORIES = {
  low_and_slow: 'Low & slow',
  ribs: 'Ribs',
  roast: 'Roast joint',
  whole_bird: 'Whole bird',
  poultry_pieces: 'Poultry pieces',
  fish: 'Fish & seafood',
  veg: 'Veg & mushrooms',
  other: 'Other'
};

export const fmtFoodType = t => (t ? FOOD_CATEGORIES[t] || t.replace(/_/g, ' ') : '—');

export const STATUS_LABELS = {
  in_progress: 'In progress',
  completed: 'Completed',
  ended_early: 'Ended early'
};

// Planned-meal days arrive as 'YYYY-MM-DD' (household-local); show e.g. "Sat 19 Sep".
export const fmtDay = day => {
  if (!day) return '—';
  const [y, m, d] = day.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString([], { weekday: 'short', day: 'numeric', month: 'short' });
};

// How a plan's day relates to the cook's finish day.
export const fmtDayOffset = offset => {
  if (offset === 0) return 'Same day';
  if (offset === -1) return 'Day before';
  if (offset === 1) return 'Day after';
  return offset < 0 ? `${-offset} days before` : `${offset} days after`;
};
